export default "__VITE_ASSET__DGH2ZUtU__"